import { appThemes } from 'withStyles';
import { translationMessages } from 'i18n';

export const DEFAULT_LOCALE: keyof typeof translationMessages = 'en';

export const DEFAULT_THEMENAME: keyof typeof appThemes = 'light';



// WEBPACK FOOTER //
// ./src/containers/App/constants.ts